<script setup lang="ts">
import WisionLogo from './WisionLogo.vue';
import Button from './Button.vue';
import LeftArrowIcon from './icons/LeftArrowIcon.vue';

const props = defineProps<{
  onSelectOrganization: (org: number) => void;
  organizations: { id: number, name: string }[];
  selectedOrganization: number | undefined;
}>();
</script>

<template>
  <div class="flex h-full flex-col items-center w-full px-10 text-onboard-shade2 max-w-2xl m-auto text-center">
    <div class="scroll-container overflow-auto w-full pb-40">
      <div class="flex flex-col mt-[20%] items-center">
        <WisionLogo :width="114" class="text-onboard-foreground" />

        <span class="text-xl mt-6 uppercase">
          {{ $t('nfc.welcome.title') }}
        </span>

        <div class="text-center mt-4 leading-none">
          <span class="text-sm uppercase">
            {{ $t('nfc.assignOrg') }}
          </span>
        </div>
      </div>
      <div class="w-full mt-6">
        <Button
          class="mt-3 h-16"
          :class="org.id === selectedOrganization && 'border-2 border-onboard-shade2 '"
          v-for="org in props.organizations"
          :key="org.id"
          @click="onSelectOrganization(org.id)"
        >
          <template v-slot:iconLeft>
            <LeftArrowIcon />
          </template>
          {{ org.name }}
        </Button>
      </div>
    </div>
    <div></div>
  </div>
</template>
<style lang="scss" scoped>
  .scroll-container {
    -ms-overflow-style: none;
    scrollbar-width: none; 
  }

  .scroll-container::-webkit-scrollbar {
    display: none;
  }

  .scroll-container::after {
    content: '';
    position: absolute;
    bottom: 0;
    width: 100%;
    height: 150px;
    left: 0;
    background: linear-gradient(rgba(255, 255, 255, 0.001), rgb(58, 57, 62));
  }

  .scroll-container::before {
    content: '';
    position: absolute;
    top: 0;
    width: 100%;
    height: 100px;
    left: 0;
    background: linear-gradient(rgb(58, 57, 62), rgba(255, 255, 255, 0.001));
  }
</style>
